angular.module('satv.media')
.factory('Audition', ['config', '$resource', function(config, $resource) {
    return $resource(config.apiUri + '/media/audition', {
    });
}]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/mediaclientbundle/Resources/js/angular/services/Audition.js